import React from "react";
import { TextField } from "@mui/material";

const CustomTextarea = (props) => {
  const {
    label,
    value,
    onChange,
    name,
    rows = 3,
    isReadOnly = false,
    ...rest
  } = props
  return (
    <TextField
      fullWidth
      multiline
      rows={rows}
      variant="outlined"
      name={name}
      // label={dis}
      value={value}
      onChange={onChange}
      InputProps={{
        readOnly: isReadOnly
      }}
      sx={{
        width: '100%',
      }}
      {...rest}
    />
  );
};

export default CustomTextarea;
